import { FC } from 'react'
import { TimeOffSummary } from 'components/Requests'
import { Card } from 'ui'
import { t } from 'translations'

type Props = {
  timeOffs: MData.TimeOff[]
  title?: string
}
const TimeOffSummaryList: FC<Props> = ({ timeOffs, title }) => {
  return (
    <Card maxHeight="10rem" className="bg-light pt-3">
      {title ? <h6 className="mx-3">{t(title)}</h6> : null}
      {timeOffs.length ? (
        <ul>
          {timeOffs.map(timeOff => (
            <li key={timeOff._id}>
              <TimeOffSummary {...timeOff} />
            </li>
          ))}
        </ul>
      ) : (
        <i className="mx-3 mb-3">{t('manager.timeOffs.NO_TIMEOFF_TO_SHOW')}</i>
      )}
    </Card>
  )
}

export default TimeOffSummaryList
